module.exports = __webpack_public_path__ + "img/product_125.e9b3f4d.webp";